module.exports = __webpack_public_path__ + "static/img/deve1.fd7f204.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/deve1.png
// module id = YKTi
// module chunks = 1